<div class="advanced-search-container">
    <div class="advanced-search-title"><span>Busqueda Avanzada</span></div>
    <ng-content class="advanced-search-body" select=".advanced-search-body">
    </ng-content>
</div>
